import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackCustom } from '../lib/pixel';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/hANGvAvMHrKFf7n3KLZ5FJ/ChatGPT_Image_24_jul_2026,_10_09_14_(1).png';
const COMPLETE_ITEMS = ['6 Tomos profesionales', '6 Recursos profesionales', 'Certificado Digital'];
const PREMIUM_ITEMS = ['Todo lo anterior', 'Vademécum Interactivo', 'Kit Consultor Profesional', 'Cuaderno de Sanación Transgeneracional'];
function PackageColumn({
  title,
  intro,
  items,
  featured = false
}: {
  title: string;
  intro: string;
  items: string[];
  featured?: boolean;
}) {
  return <article className={`rounded-2xl border p-5 md:p-7 ${featured ? 'border-[#C2683D]/70 bg-white shadow-lg ring-1 ring-[#C2683D]/20' : 'border-[#2E4F48]/20 bg-white shadow-sm'}`} data-id="element-213" data-mp="3hnezrqpbrvt2">
      {featured && <span className="mb-3 inline-flex rounded-full bg-[#C2683D] px-3 py-1 text-[10px] font-bold tracking-[0.15em] text-white" data-id="element-214" data-mp="3rk07ijsqbl0l">
          RECOMENDADO
        </span>}
      <h3 className="font-serif text-2xl font-bold text-[#1C3B36]" data-id="element-215" data-mp="26a67mjy6bzmn">{title}</h3>
      <p className="mt-1 text-sm font-semibold text-[#44574F]" data-id="element-216" data-mp="2b8pssi4y17dy">{intro}</p>
      <ul className="mt-5 space-y-3" data-id="element-217" data-mp="2f8ryd2dsukyi">
        {items.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-[#1C3B36]" data-id="element-218" data-mp="2fbmg2m5fhro8">
            <span className="mt-0.5 text-[#C2683D]" data-id="element-219" data-mp="2k606ea58h8m1">✓</span>
            {item}
          </li>)}
      </ul>
    </article>;
}
export function PackageOverviewSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-[#2E4F48]/15 bg-[#E8E0D3] px-4 py-10 sm:px-6 md:py-16" data-id="element-220" data-mp="2yxiqaj17rnao">
      <div ref={ref} className={`reveal container mx-auto max-w-6xl ${visible ? 'is-visible' : ''}`} data-id="element-221" data-mp="32ym8vdanbxfl">
        <div className="grid items-center gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-222" data-mp="37z057y2vxixs">
          <div className="order-2 text-center lg:order-1 lg:text-left" data-id="element-223" data-mp="3cw8s2byzab5d">
            <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-224" data-mp="1cusg90wxrpsy">TU FORMACIÓN, CLARA Y COMPLETA</p>
            <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-[#1C3B36] md:text-5xl" data-id="element-225" data-mp="17vz87o0f4r06">
              ¿Qué vas a recibir exactamente?
            </h2>
            <p className="mt-4 text-base leading-relaxed text-[#44574F]" data-id="element-226" data-mp="1mmomiz96em89">
              Elegí la formación que mejor acompañe tu momento. Las dos opciones
              incluyen material profesional, acceso inmediato y certificado.
            </p>
            <img src={PRODUCT_IMG} alt="Contenido incluido en la formación de Biodecodificación" className="mx-auto mt-6 w-full max-w-sm object-contain drop-shadow-[0_18px_35px_rgba(28,59,54,0.18)] lg:mx-0" data-id="element-227" data-mp="1rkgf7vhnacdi" />
          </div>

          <div className="order-1 grid gap-4 sm:grid-cols-2 lg:order-2" data-id="element-228" data-mp="b56rqp9kowxv">
            <PackageColumn title="Formación Completa" intro="La base sólida para empezar." items={COMPLETE_ITEMS} data-id="element-229" data-mp="b79t25g6echw" />
            <PackageColumn title="Formación Premium" intro="Todo lo necesario para profundizar y aplicar." items={PREMIUM_ITEMS} featured data-id="element-230" data-mp="2hu7hbtazh6nx" />
          </div>
        </div>

        <div className="mt-7 text-center" data-id="element-231" data-mp="2d2z5yrq3fb84">
          <a href="#pricing" onClick={() => trackCustom('ViewPricingIntent', {
          source: 'package-overview'
        })} className="inline-flex items-center justify-center rounded-xl bg-[#1C3B36] px-8 py-4 text-sm font-bold tracking-[0.12em] text-white shadow-[0_10px_24px_rgba(28,59,54,0.2)] transition-all hover:-translate-y-1 hover:bg-[#2E4F48]" data-id="element-232" data-mp="2d1xkdtbgb6c5">
            QUIERO ACCEDER
          </a>
        </div>
      </div>
    </section>;
}